import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const memberRoutes: RouteRecordRaw[] = [
  {
    path: '/member',
    name: 'Member',
    component: Layout,
    meta: {
      title: '用户管理',
      icon: 'vi-ant-design:user-outlined',
      alwaysShow: true
    },
    children: [
      {
        path: 'manage',
        name: 'MemberManage',
        meta: {
          title: '用户管理',
          icon: 'mdi-account-group-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'list',
            component: () => import('@/views/Admin/Member/List.vue'),
            name: 'MemberList',
            meta: { title: '全部用户' }
          },
          {
            path: 'types',
            component: () => import('@/views/Admin/Member/Types.vue'),
            name: 'MemberTypes',
            meta: { title: '用户类别' }
          },
          {
            path: 'real-list',
            component: () => import('@/views/Admin/Member/RealList.vue'),
            name: 'MemberRealList',
            meta: { title: '实名认证' }
          },
          {
            path: 'avatar-list',
            component: () => import('@/views/Admin/Member/AvatarList.vue'),
            name: 'MemberAvatarList',
            meta: { title: '系统头像' }
          }
        ]
      },
      {
        path: 'user-risk',
        name: 'MemberUserRisk',
        meta: {
          title: '用户风控',
          icon: 'mdi-shield-account-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'anti-addiction',
            component: () => import('@/views/Admin/Member/Risk/AntiAddiction.vue'),
            name: 'MemberRiskAntiAddiction',
            meta: { title: '防沉迷设置', icon: 'mdi-shield-check-outline' }
          }
        ]
      },
      {
        path: 'invite-reward',
        component: () => import('@/views/Admin/Member/InviteReward.vue'),
        name: 'MemberInviteReward',
        meta: { title: '邀请人数奖励', icon: 'mdi-account-multiple-plus' }
      },
      {
        path: 'partner-list',
        component: () => import('@/views/Admin/Member/PartnerList.vue'),
        name: 'MemberPartnerList',
        meta: { title: '经销商', hidden: true }
      },
      {
        path: 'level-list',
        component: () => import('@/views/Admin/Member/LevelList.vue'),
        name: 'MemberLevelList',
        meta: { title: '等级', hidden: true }
      },
      {
        path: 'level-log',
        component: () => import('@/views/Admin/Member/LevelLog.vue'),
        name: 'MemberLevelLog',
        meta: { title: '升级记录', hidden: true }
      },
      {
        path: 'black-list',
        component: () => import('@/views/Admin/Member/BlackList.vue'),
        name: 'MemberBlackList',
        meta: { title: '黑名单管理', icon: 'mdi-account-cancel' }
      },
      {
        path: 'money-log',
        component: () => import('@/views/Admin/Member/MoneyLog/List.vue'),
        name: 'MemberMoneyLogList',
        meta: { title: '资金日志', icon: 'mdi-currency-usd' }
      },
      {
        path: 'sign-activity',
        component: () => import('@/views/Admin/Member/Sign/Activity.vue'),
        name: 'MemberSignActivity',
        meta: { title: '签到活动', icon: 'mdi-calendar-check-outline' }
      },
      {
        path: 'sign-reward-config',
        component: () => import('@/views/Admin/Member/Sign/RewardConfig.vue'),
        name: 'MemberSignRewardConfig',
        meta: { title: '签到奖励配置', icon: 'mdi-gift-outline' }
      },
      {
        path: 'sign-record',
        component: () => import('@/views/Admin/Member/Sign/Record.vue'),
        name: 'MemberSignRecord',
        meta: { title: '用户签到记录', icon: 'mdi-clipboard-text-clock-outline' }
      },
      {
        path: 'sign-status',
        component: () => import('@/views/Admin/Member/Sign/Status.vue'),
        name: 'MemberSignStatus',
        meta: { title: '用户签到状态', icon: 'mdi-calendar-clock-outline' }
      },
      {
        path: 'wallet',
        name: 'MemberWallet',
        meta: { title: '钱包管理', alwaysShow: true, hidden: true },
        children: [
          {
            path: 'list',
            component: () => import('@/views/Admin/Member/Wallet/List.vue'),
            name: 'MemberWalletList',
            meta: { title: '用户钱包' }
          },
          {
            path: 'register',
            component: () => import('@/views/Admin/Member/Wallet/Register.vue'),
            name: 'MemberWalletRegister',
            meta: { title: '钱包注册' }
          },
          {
            path: 'address',
            component: () => import('@/views/Admin/Member/Wallet/Address.vue'),
            name: 'MemberWalletAddress',
            meta: { title: '钱包地址' }
          },
          {
            path: 'log',
            component: () => import('@/views/Admin/Member/Wallet/Log.vue'),
            name: 'MemberWalletLog',
            meta: { title: '交易日志' }
          },
          {
            path: 'transfer',
            component: () => import('@/views/Admin/Member/Wallet/Transfer.vue'),
            name: 'MemberWalletTransfer',
            meta: { title: '内部转账' }
          }
        ]
      },
      {
        path: 'risk',
        name: 'MemberRisk',
        meta: {
          title: '风控中心',
          icon: 'mdi-shield-alert-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'config',
            component: () => import('@/views/Admin/Member/Risk/Config.vue'),
            name: 'MemberRiskConfig',
            meta: { title: '风险配置', icon: 'mdi-cog-outline' }
          }
        ]
      },
      {
        path: 'messages',
        name: 'MemberMessages',
        component: getParentLayout(),
        meta: { title: '消息管理', icon: 'mdi-message-text-outline', alwaysShow: true },
        children: [
          {
            path: 'categories',
            name: 'MemberMessageCategories',
            component: () => import('@/views/Admin/Business/Shop/MessageCategory.vue'),
            meta: { title: '消息分类', icon: 'mdi-format-list-bulleted-type' }
          },
          {
            path: 'list',
            name: 'MemberMessageList',
            component: () => import('@/views/Admin/Business/Shop/MessageList.vue'),
            meta: { title: '消息列表', icon: 'mdi-message-bulleted' }
          }
        ]
      }
    ]
  }
]

export default memberRoutes
